(function() {

    'use strict';

    angular.module('app').
    controller('AreaDetailsController', AreaDetailsController);

    AreaDetailsController.$inject = [
        '$q', 
        '$scope', 
        '$routeParams', 
        '$timeout', 
        '$location', 
        'hasDuplicate', 
        'toastr', 
        'Location', 
        'FleetService', 
        'Carrier', 
        'JobsTableService', 
        'ConfirmationModalFactory', 
        'ViewChangeNotificationFactory'
    ];

    function AreaDetailsController(
        $q, 
        $scope, 
        $routeParams, 
        $timeout, 
        $location, 
        hasDuplicate, 
        toastr, 
        Location, 
        FleetService, 
        Carrier, 
        JobsTableService, 
        ConfirmationModalFactory, 
        ViewChangeNotificationFactory
    ){
        const vm = this;

        const viewConfirmation = new ConfirmationModalFactory({}, {
            message: 'messages.warning.viewChange.MESSAGE',
            code: 'messages.warning.viewChange.CODE',
        });
        const toInactiveConf = new ConfirmationModalFactory({},{
            message: 'messages.warning.statusChange.MESSAGE.TO_RECORD_INACTIVE',
            code: 'messages.warning.statusChange.CODE'
        });
        const toActiveConf = new ConfirmationModalFactory({},{
            message: 'messages.warning.statusChange.MESSAGE.TO_RECORD_ACTIVE',
            code: 'messages.warning.statusChange.CODE'
        });
        const deleteConf = new ConfirmationModalFactory({},{
            message: 'messages.warning.statusChange.MESSAGE.DELETE_RECORD',
            code: 'messages.warning.statusChange.CODE'
        });
        const onRouteChange = $scope.$on('$routeChangeStart', function(event, next, current, test) {
            if(!vm.viewMode && isDataChanged(vm.area, vm.areaRaw)){
                viewConfirmation.getInstance().result.then(function (cond) {
                    if (cond) {
                        onRouteChange();
                        let nextRoute = next.$$route.originalPath;
                        if( _.contains(next.$$route.originalPath, ':') ){
                            nextRoute = nextRoute.split(':')[0];
                        }
                        $location.path(nextRoute);
                    }
                });
                event.preventDefault();
            }
        });

        vm.id = $routeParams.id;
        vm.viewMode = false;
        vm.isUnique = isUnique;
        vm.searchCarrierProfiles = searchCarrierProfiles;
        vm.searchZonesPostcodes = searchZonesPostcodes;
        vm.getNonSelected = getNonSelected;
        vm.changeStatus = changeStatus;
        vm.save = save;
        vm.deleteArea = deleteArea;
        vm.jobTypes = {'p2p': 'Point to point', 'pickuponly': 'Pickup Only', 'delivery': 'Delivery'};
        vm.jobTypesArr = ['p2p', 'pickuponly', 'delivery'];
        (()=>{
            if(vm.id){
                vm.isFetching = true;
                FleetService.Areas.get(vm.id,data=>{
                    initArea(data);
                    vm.isFetching = false;
                }, error=>{
                    toastr.error('Route not found', error.message);
                    vm.isFetching = false;
                })
            }else{
                initArea({});
            }
        })();

        function isUnique(model) {
            if (!model) {
                return;
            }
            vm.checkingDups = true;
            hasDuplicate({
                serviceCallback: FleetService.Areas.getAll,
                callbackFormat: ['success', 'error', 'filter'],
                findBy: 'content',
                compareWith: model.toLowerCase(),
                compareBy: 'areaId',
                raw: (angular.getObjVal(vm, 'areaRaw.areaId') || '').toLowerCase(),
                ignoreCase: true,
                warningMsg: 'Area ID already taken',
                filters: {
                    size: 2,
                    areaId: model
                }
            }).then(res => {
                vm.codeError = !!res;
                vm.checkingDups = false;
            }).catch(err => {
                vm.checkingDups = false;
            });
        }

        function searchCarrierProfiles(select) {
            if(!select.open)
                return false;
            vm.searching = true;
            vm.carrierProfiles = [];
            Carrier.carrierProfilesCompact(data=>{
                vm.carrierProfiles = data.content.sort((a, b) => a.name.localeCompare(b.name));
                vm.searching = false;
            }, error=> {
                vm.searching = true;
                toastr.error('Unable to search for vehicle types', error.message);
            }, {
                name: select.search,
                isReceived: true,
                size: 100
            })
        }
        function searchZonesPostcodes(select) {
            if(!select.open){
                return false;
            }
            vm.searching = true;
            vm.zonesPostcodes = [];
            $q.all({
                zones: searchZones(vm.area.carrierProfile, select),
                //postcode: searchPostcodes(vm.area, select),
                //suburb: searchSuburb(vm.area, select)
            }).then(res=>{
                vm.zonesPostcodes.push(...getNonSelected(vm.area.zones, res.zones, 'id'));
                /*vm.zonesPostcodes.push(...res.postcode);
                vm.zonesPostcodes.push(...res.suburb);*/
            }).finally(()=>{
                vm.searching = false;
            });
        }

        function getNonSelected(selected, list, field) {
            return selected.reduce((total, item, i)=>{
                return total.filter(l=>item[field] !== l[field]);
            }, list);
        }
        function searchZones(carrierProfile, select) {
            let defer = $q.defer();
            if(!carrierProfile){
                $timeout(()=>defer.resolve([]));
                return defer.promise
            }
            Carrier.getZonePostcodeFileDetail(carrierProfile.id, data=>{
                defer.resolve(data.content.map(zone=>angular.extend(zone, {type: 'Zones'})));
            }, error=>{
                defer.reject(error);
            },{
                name: select.search,
                isFleet: true
            });
            return defer.promise;
        }

        function searchPostcodes(area, select) {
            let defer = $q.defer();
            Location.ZipCode({
                size: 10,
                sort: 'code',
                code: select.search
            }, function (data) {
                defer.resolve(buildStates(data.content));
            }, function (err) {

            });
            return defer.promise;
        }

        function searchSuburb(area, select) {
            let defer = $q.defer();
            Location.ZipCode({
                size: 30,
                sort: 'code',
                name: select.search
            }, function (data) {
                defer.resolve(data.content.map(suburb=>angular.extend(suburb,{type: 'Suburb'})));
            }, function (err) {

            });
            return defer.promise;
        }

        function buildStates(codes) {
            var distinctCodes = [];
            angular.forEach(codes, function (code, key) {
                angular.extend(code, {type: 'Postcodes'});
                if (codes[key - 1] && code.code == codes[key - 1].code) {
                    distinctCodes[distinctCodes.length - 1].altStates.push(angular.copy(code));
                } else {
                    code.altStates = [angular.copy(code)];
                    distinctCodes.push(angular.copy(code));
                }
            });
            return distinctCodes;
        }

        function initArea(data) {
            let {zones, jobTypes, availableJobTypes} = data;
            vm.area = angular.extend(data, {
                zones: zones ? zones.map(zone=>zone.zone) : [],
                carrierProfile : zones && zones.length && zones[0].zone ? zones[0].zone.carrierProfile : null,
                jobTypes: jobTypes || availableJobTypes || []
            });

            initJobsTable(vm.area);
            vm.areaRaw = angular.copy(data);
        }

        function initJobsTable(area) {
            vm.jobsTable = new JobsTableService({
                area,
                referrer: 'area'
            }).tableData;
        }

        function changeStatus(event, active) {
            event.preventDefault();
            if (vm.area.active) {
                vm.area.active = false;
                toActiveConf.getInstance().result.then(function(cond) {
                    if (cond) {
                        $timeout(function () {
                            vm.area.active = true;
                        });
                    }
                });
            }
            else {
                vm.area.active = true;
                toInactiveConf.getInstance().result.then(function(cond) {
                    if (cond) {
                        $timeout(function () {
                            vm.area.active = false;
                        });
                    }
                });
            }
        }
        function isDataChanged(o, n) {
            return !angular.equals(o, n)
        }
        function cleanPayload(payload) {
            const {
                active,
                areaId,
                carrierProfile,
                jobTypes,
                zones,
                sortCode
            } = payload;
            return {
                active,
                areaId,
                carrierProfileId: carrierProfile.id,
                jobTypeIds: jobTypes.map(type=>type.name || type),
                zoneIds: zones.map(zone=>zone.id),
                sortCode
            };
        }
        function save(form) {
            form.$setSubmitted();
            if(form.$invalid){
                return false;
            }
            vm.saveInProgress = true;
            if($routeParams.id){
                FleetService.Areas.update(vm.id, cleanPayload(vm.area), result=>{
                    vm.saveInProgress = false;
                    toastr.success('Data successfully updated');
                    vm.areaRaw = angular.copy(vm.area);
                }, err=>{
                    vm.saveInProgress = false;
                    toastr.error(err.message);
                })
            }else{
                FleetService.Areas.create(cleanPayload(vm.area), result=>{
                    onRouteChange();
                    $location.path('/areas/details/' + result.id);
                    toastr.success('Data successfully created');
                }, err=>{
                    vm.saveInProgress = false;
                    toastr.error(err.message);
                })
            }
        }
        function deleteArea(area) {
            deleteConf.getInstance().result.then(cond=>{
                if(cond){
                    FleetService.Areas.delete(area.id, data=>{
                        toastr.success('Area successfully deleted');
                        onRouteChange();
                        $location.path('/areas');
                    }, err=>{
                        toastr.error('Unable to do request. Please try again later', err.message);
                    })
                }
            });
        }
    }
})();



// WEBPACK FOOTER //
// ./js/controllers/routes/AreaDetailsController.js